// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"6c070329","313":"16183269","326":"68c5a890","333":"bd3cf41a","609":"445c09ed","643":"2b5a0058","758":"7c9e1f74","826":"fd49c81a","870":"24d03141"}[chunkId] + ".chunk.js";
};